<template>
  <transition name="fade" v-if="isShow">
    <div class="time-select">
      <!-- <div style="text-align: center; line-height: 0.48rem">请选择{{isShowStartTime ? '起始' : '结束'}}时间</div> -->
      <ul class="time-box" v-if="isShowStartTime">
        <li v-for="item in 24" :class="{disable: firstTime > item || item > (24 - miniTimeRange)}" @click="selectStartTime(item)" :key="item">{{item + ':00'}}</li>
      </ul>
      <ul class="time-box" v-show="isShowEndTime">
        <li v-for="item in 24" :class="{disable: (firstTime + miniTimeRange) > item}" @click="selectEndTime(item)" :key="item">
          {{item + ':00'}}
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      isShow: {
        type: Boolean,
        required: true
      },
      startTime: {
        type: Number,
        required: true
      }
    },
    data () {
      return {
        firstTime: null,
        elastTime: null,
        isShowStartTime: true,
        isShowEndTime: false,
        miniTimeRange: 1 // 最小时间间隔
      }
    },
    created () {
//      this.startTime = new Date().getHours()
//      this.endTime = this.startTime + this.miniTimeRange
      this.firstTime = this.startTime
    },
    methods: {
      selectStartTime (item) {
        if (item < this.firstTime || item > (24 - this.miniTimeRange)) {
          return
        }
        this.firstTime = item
        this.$emit('select-start-time', this.firstTime)
        this.isShowStartTime = false
        this.isShowEndTime = true
      },
      selectEndTime (item) {
        if (item < this.firstTime + this.miniTimeRange) {
          return
        }
        this.lastTime = item
        this.$emit('select-end-time', this.lastTime)
        this.isShowEndTime = false
      }
    }
  }
</script>

<style scoped type="text/css" lang="stylus">
  @import '../../common/css/mixmin'
  .time-select
    width px2rem(400px)
    position absolute
    z-index 100
    font-size px2rem(24px)
    left 50%
    top 100%
    transform translate3d(-50%, 0, 0)
    -webkit-transform translate3d(-50%, 0, 0)
    box-shadow 0 0 px2rem(10px) #ccc
    opacity 1
    background-color #fff
    &.fade-enter-active, &.fade-leave-active
      transition opacity .3s
    &.fade-enter, &.fade-leave-active
      opacity 0
    .time-box
      padding px2rem(20px)
      margin 0
      font-size 0
      line-height px2rem(60px)
      li
        padding 0
        margin 0
        font-size px2rem(24px)
        width 25%
        height px2rem(60px)
        color #6b7d8e
        line-height px2rem(60px)
        display inline-block
        list-style none
        text-align center
        border-radius 4px
        cursor pointer
        &.active, &:not(.disable):hover
          color #fff
          background-color rgba(78, 209, 255, 1)
        &.disable
          cursor not-allowed
          color #ddd
</style>



// WEBPACK FOOTER //
// time.vue?4cce7a8d